export default "__VITE_ASSET__CUF63_56__"